<template>
  <naj-box :title="locales.title">
    <v-row>
      <v-col cols="4">
        <naj-input
          :type-id="formFieldType.number"
          :label="locales.husbandNationalId"
          :value.sync="formModel.husbandNationalId"
          :validates="validation"
          :disabled="viewMode"
          @input="resetForm"
        ></naj-input>
      </v-col>
      <v-col cols="4">
        <naj-input
          :type-id="formFieldType.number"
          :label="locales.wifeNationalId"
          :value.sync="formModel.wifeNationalId"
          :validates="validation"
          :disabled="viewMode"
          @input="resetForm"
        ></naj-input>
      </v-col>
      <v-col
        v-if="!formModel.isMarriageInstrumentRetrieved"
        cols="3"
        align-self="center"
        class="text-right"
      >
        <naj-button
          square
          :loading="isBtnChecking"
          :disabled="isCheckBtnDisabled"
          @click="check"
        >
          {{ local.personInformation.check }}
        </naj-button>
      </v-col>
      <v-col
        v-else
        cols="3"
      >
        <naj-error-text
          :text="formModel.confirmationTxt"
          size="medium"
          no-margin
        ></naj-error-text>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <naj-input
          :type-id="formFieldType.date"
          :label="locales.eventData"
          :value.sync="formModel.eventDate"
          :disabled="true"
        ></naj-input>
      </v-col>
      <v-col cols="4">
        <naj-input
          :type-id="formFieldType.text"
          :label="locales.martialStatus"
          :value.sync="formModel.martialStatus"
          :disabled="true"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.husbandName"
              :value.sync="formModel.husbandName"
              :disabled="true"
            ></naj-input>
          </v-col>
          <v-col cols="2">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.husbandBirthCity"
              :value.sync="formModel.husbandBirthCity"
              :disabled="true"
            ></naj-input>
          </v-col>
          <v-col cols="6">
            <naj-input
              :type-id="formFieldType.date"
              :label="locales.husbandBirthDate"
              :value.sync="formModel.husbandBirthDate"
              :disabled="true"
            ></naj-input>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.wifeName"
              :value.sync="formModel.wifeName"
              :disabled="true"
            ></naj-input>
          </v-col>
          <v-col cols="2">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.wifeBirthCity"
              :value.sync="formModel.wifeBirthCity"
              :disabled="true"
            ></naj-input>
          </v-col>
          <v-col cols="6">
            <naj-input
              :type-id="formFieldType.date"
              :label="locales.wifeBirthDate"
              :value.sync="formModel.wifeBirthDate"
              :disabled="true"
            ></naj-input>
          </v-col>
          <v-col
            v-if="isDivorce"
            cols="4"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.divorceStatus"
              :value.sync="formModel.divorceStatus"
              :disabled="true"
            ></naj-input>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </naj-box>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapState } = createNamespacedHelpers('LawsuitModule');

export default {
  inject: ['$validator'],
  name: 'CheckMarriageDeed',
  props: {
    validates: {
      type: Object,
      default: () => ({}),
    },
    formModel: {
      type: Object,
      required: true,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isBtnChecking: false,
      isDeedsRetrieved: false,
    };
  },
  computed: {
    locales() {
      return this.local.dynamicFormAdmin.customComponents.checkDeeds;
    },
    isDivorce() {
      return this.formModel.divorceStatus;
    },
    isCheckBtnDisabled() {
      return ((!this.formModel.husbandNationalId || !this.formModel.wifeNationalId || this.isBtnChecking));
    },
    isVerified() {
      return this.formModel.isMarriageInstrumentRetrieved;
    },
    validation() {
      return {
        long: true,
        max: 10,
        isVerified: this.isVerified,
        ...this.validates,
      };

    },

  },
  methods: {
    ...mapActions(['checkMarriageDeeds']),
    resetForm() {
      this.$set(this.formModel, 'eventDate', null);
      this.$set(this.formModel, 'husbandBirthDate', null);
      this.$set(this.formModel, 'husbandName', null);
      this.$set(this.formModel, 'husbandBirthCity', null);
      this.$set(this.formModel, 'wifeBirthDate', null);
      this.$set(this.formModel, 'wifeName', null);
      this.$set(this.formModel, 'wifeBirthCity', null);
      this.$set(this.formModel, 'martialStatus', null);
      this.$set(this.formModel, 'divorceStatus', null);
      this.$set(this.formModel, 'isMarriageInstrumentRetrieved', false);
      this.isBtnChecking = false;
    },
    check() {
      this.$nextTick(() => {
        this.isBtnChecking = true;
        this.$set(this.formModel, 'isMarriageInstrumentRetrieved', false);
        this.checkMarriageDeeds(this.formModel)
          .then((res) => {
            this.toaster.success(this.local.common.verificationSucceeded);
            let data = res.requestInfoModels[0];
            this.$set(this.formModel, 'eventDate', data.model.actualEventDate);
            this.$set(this.formModel, 'husbandBirthDate', data.model.husband.dateOfBirth);
            this.$set(this.formModel, 'husbandName', data.model.husband.fullName);
            this.$set(this.formModel, 'husbandBirthCity', data.model.husband.country);
            this.$set(this.formModel, 'wifeBirthDate', data.model.wife.dateOfBirth);
            this.$set(this.formModel, 'wifeName', data.model.wife.fullName);
            this.$set(this.formModel, 'wifeBirthCity', data.model.wife.country);
            this.$set(this.formModel, 'martialStatus', `${data.documentTypeName}(${data.documentStatusName})`);
            if (data.model.divorceStatusName !== null)
              this.$set(this.formModel, 'divorceStatus', `${data.model.divorceStatusName}`);
            this.$set(this.formModel, 'isMarriageInstrumentRetrieved', true);
            this.$set(this.formModel, 'confirmationTxt', '');
          })
          .catch((err) => {
            this.$set(this.formModel, 'confirmationTxt', err);
            this.$set(this.formModel, 'isMarriageInstrumentRetrieved', false);
          })
          .finally(() => {
            this.isBtnChecking = false;
          });
      });
    },
  },
};
</script>